<template>
  <div>
    <v-server-table
      id="iframeBiosignalsAccessCodes"
      ref="iframeBiosignalsAccessCodes"
      name="iframeBiosignalsAccessCodes"
      :columns="columns"
      :options="tableOptions"
      @filter="onFilterUpdate"
      >
      <span slot="validUntil" class="no-break" slot-scope="props">{{ props.row.validUntil | localTime('YYYY-MM-DD HH:mm') }}</span>
      <span slot="status" :style="{ color: props.row.usedAt ? '#39afc9' : props.row.expired ? '#d33b3b' : '#60a841' }" class="no-break" slot-scope="props">{{ handleCodeStatus(props.row) }}</span>
      <span slot="testFlow" class="no-break" slot-scope="props">{{ props.row.testFlow ? `${props.row.testFlow.name} (${props.row.testFlow.hash})`: "N/A" }}</span>

    </v-server-table>
  </div>
</template>

<script>
import TableQueryMixin from '@/mixins/TableQueryMixin.vue';
import MultiselectLabelFormatter from '@/mixins/MultiselectLabelFormatter.vue';
import ClustersAndEntitiesMixin from '@/mixins/ClustersAndEntitiesMixin.vue';
import RangeDatePicker from '@/components/common/RangeDatePicker.vue';
import Multiselect from 'vue-multiselect';
import LocalStorageHelper from '@/local-storage/LocalStorageHelper';
import { TABLE_IFRAME_BIOSIGNALS_ACCESS_CODES } from '@/local-storage/LocalStorageKeys';
import { get as _get } from 'lodash';
import { IframeService } from '@/api/IframeService';

export default {
  name: 'BiosignsAccessCodesTable',
  components: { Multiselect, RangeDatePicker },
  mixins: [
    TableQueryMixin,
    MultiselectLabelFormatter,
    ClustersAndEntitiesMixin
  ],
  props: {
    filters: {
      type: Object,
      required: true
    },
    component: {
      type: Object,
      required: true
    },
    serviceSlug: {
      type: String,
      required: true
    },
  },
  data: function () {
    return {
      entitiesOptions: [],
      queryUrl: `${this.$store.state.iframe_server}v1/biosignals/accesscodes`,
      columns: ['validUntil', 'code', 'status', 'testFlow'],
      tableOptions: {
        orderBy: {
          column: 'validUntil',
          ascending: false
        },
        saveState: true,
        storage: 'local',
        filterable: true,
        sortable: ['validUntil'],
        customFilters: ['entities', 'statuses'],
        headings: {
          validUntil: this.$t('biosigns.accessCodes.columns.validUntil'),
          code: this.$t('biosigns.accessCodes.columns.code'),
          expired: this.$t('biosigns.accessCodes.columns.expired'),
          status: this.$t('biosigns.accessCodes.columns.status'),
          testFlow: this.$t('biosigns.accessCodes.columns.testFlow'),
        },
        columnsClasses: {
          validUntil: 'biosignsCodesCenter',
          code: 'accessCode',
          status: 'biosignsCodesCenter',
          testFlow: 'biosignsCodesCenter'
        }
      },

    }
  },

  methods: {
    handleCodeStatus: function (accessCode) {
      if (accessCode.usedAt) {
        return this.$t('biosigns.accessCodes.statuses.used_at', {date: this.$options.filters.localTime(accessCode.usedAt, 'YYYY-MM-DD HH:mm')})
      } else if(accessCode.expired) {
        return this.$t('biosigns.accessCodes.statuses.expired')
      }
      return this.$t('biosigns.accessCodes.statuses.active')
    },


  },
  computed: {

  },
  watch: {
    'filters.statuses': function (value) {
      if(value) {
        this.emitTableFilter(`vue-tables.iframeBiosignalsAccessCodes.filter::statuses`, value.map(elem => elem.slug).join(',') || '')
      } else {
        this.emitTableFilter(`vue-tables.iframeBiosignalsAccessCodes.filter::statuses`, '')
      }
    },
    'filters.entities': function (value) {
      if (value) {
        //const parsedIds = value.map(elem => parseInt(elem.id)).join(',')
        //this.emitTableFilter(`vue-tables.iframeBiosignalsAccessCodes.filter::entities`, parsedIds || '')
        this.emitTableFilter(`vue-tables.iframeBiosignalsAccessCodes.filter::entities`, value.id || '')
      } else {
        this.emitTableFilter(`vue-tables.iframeBiosignalsAccessCodes.filter::entities`, '')
      }
    },
  }
};
</script>

<style lang="scss">
.biosignsCodesCenter {
  text-align: center;
}
.accessCode {
  text-align: center;
  font-weight: bold;
}
</style>
